export default __webpack_public_path__ + "static/media/arcgis-utility-network.62e8037a.svg";